
export class TipoInterface {

    public id: string;
    public nome: string;

    constructor(){
        
    }
}
